export function disableInputScroll(
    numberInputRef: React.RefObject<HTMLInputElement>
) {
    const inputElem = numberInputRef.current;
    const disableScroll = (e: WheelEvent) => e.preventDefault();
    inputElem?.addEventListener("wheel", disableScroll, { passive: false });
    return () => inputElem?.removeEventListener("wheel", disableScroll);
}
